import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Content.css'

import LearningAssessment from '../LearningAssessment'
import RelatedContent from '../RelatedContent'
import HeadingFactory from '../HeadingFactory'
import {
  GetTopicNavigationInfoByPathName,
  TabMap
} from '../common/TabNavigation'
import InfoConcept from '../InfoConcept'

import CallToAction from '@healthwise-ui/content/CallToAction'
import MediaGallery from '@healthwise-ui/content/MediaGallery'
import SvgImage from '@healthwise-ui/core/SvgImage'

class Content extends Component {
  shouldShowHeader(item, title) {
    return (item.aspect || '').indexOf('[decisionOptions]') === -1
  }

  getHeadingIconImage(item) {
    const hasHtml = item && item.html
    const hasIntroHtml =
      item &&
      Array.isArray(item.content) &&
      item.content.length !== 0 &&
      item.content[0].intro
    if (!hasHtml && !hasIntroHtml) {
      return null
    }

    const html = hasIntroHtml ? item.content[0].intro : item.html
    if (html.indexOf('wIconTitle') === -1) {
      return null
    }

    let parser = new window.DOMParser()
    let doc = parser.parseFromString(html, 'text/html')
    let image = doc.querySelector('.HwIconTitle')

    if (!image) {
      image = doc.querySelector('.hwIconTitle')
    }
    const src = image.getAttribute('src')

    if (src) {
      return <SvgImage src={src} />
    }

    return null
  }

  render() {
    const {
      actionButtons,
      onQuestionRender,
      readonly,
      item,
      mediaServiceUrl,
      mediaHash,
      mediaToken,
      responseState,
      isSummary,
      sectionIndex,
      resourcesRoot,
      location,
      navigationInfo
    } = this.props

    const currentLocation =
      location ||
      GetTopicNavigationInfoByPathName(navigationInfo, window.location.pathname)
        .tab
    const image = this.getHeadingIconImage(item)
    const header = this.shouldShowHeader(
      this.props.item,
      item.title.consumer
    ) ? (
      <HeadingFactory
        currentLocation={currentLocation}
        sectionIndex={sectionIndex}
        image={image}
      >
        {item.title.consumer}
      </HeadingFactory>
    ) : null

    switch (item.type) {
      case 'hwDecisionComponent':
        return (
          <section className={styles.content_section}>
            {header}
            <InfoConcept
              item={item}
              navigationInfo={navigationInfo}
              title={item.title.consumer}
              currentLocation={currentLocation}
            />
          </section>
        )
      case 'hwDecisionAssessment':
        return (
          <section
            className={styles.content_section}
            data-page-order={this.props['data-page-order']}
          >
            {header}
            <LearningAssessment
              item={item}
              responseState={responseState}
              onQuestionRender={onQuestionRender}
              readonly={readonly}
            />
          </section>
        )
      case 'hwGallery':
      case 'Gallery':
        return (
          <section
            className={styles.content_section + ' ' + styles.hide_for_print}
          >
            {header}
            {isSummary ? (
              <RelatedContent
                item={item}
                mediaServiceUrl={mediaServiceUrl}
                mediaHash={mediaHash}
                mediaToken={mediaToken}
              />
            ) : (
              <MediaGallery
                item={item}
                resourcesRoot={resourcesRoot}
                mediaServiceUrl={mediaServiceUrl}
                mediaHash={mediaHash}
                mediaToken={mediaToken}
              />
            )}
          </section>
        )
      case 'hwMessage':
        return <CallToAction item={item} actionButtons={actionButtons} />

      default:
        return <div>{item.type}</div>
    }
  }
}

Content.propTypes = {
  responseState: PropTypes.object,
  navigationInfo: PropTypes.array,
  sectionIndex: PropTypes.number,
  mediaServiceUrl: PropTypes.string,
  mediaHash: PropTypes.string,
  mediaToken: PropTypes.string,
  location: PropTypes.oneOf(TabMap),
  resourcesRoot: PropTypes.string,
  item: PropTypes.shape({
    title: PropTypes.shape({
      consumer: PropTypes.string.isRequired
    }).isRequired,
    type: PropTypes.oneOf([
      'hwDecisionComponent',
      'hwDecisionAssessment',
      'hwGallery',
      'Gallery',
      'hwMessage'
    ])
  }).isRequired,
  actionButtons: PropTypes.node,
  onQuestionRender: PropTypes.func,
  readonly: PropTypes.bool,
  isSummary: PropTypes.bool
}

export default Content



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/Content/index.js